// extracted by mini-css-extract-plugin
export default {"backdrop":"Model_backdrop__1rVjy","modal":"Model_modal__Myson","slide-down":"Model_slide-down__5104O"};